@if (authenticated && domainConfig) {
  <app-page-container />
}
